// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Section 2 — Decryptage et ouverture des plis (vue acheteur MS, V2).
   Une unite par prestataire : carte annuaire (gauche, classes globales .prestataire-card*
   compactees ici) + panneau d'offre (droite). Horizontal pour limiter la hauteur.
   Co-localise au fork OperationConsultationSuivi (ne pas dependre du .css de l'oracle). */

.consultation-presta-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1.25rem;
  margin-top: 0.25rem;
}

.cs-unit {
  display: flex;
  gap: 1rem;
  align-items: stretch;
  flex: 1 1 320px;
  padding: 0.75rem;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

/* Tant que le prestataire n'a pas repondu (refus, expire, attente) : seul le panneau d'offre
   (droite) passe en gris. La carte annuaire (gauche) reste blanche, sinon elle se confond avec
   le fond et devient illisible. */
.cs-unit--grise {
  background: #fff;
}

.cs-unit--grise .cs-unit-card {
  background: #fff;
}

.cs-unit--grise .cs-unit-offre {
  background: #f3f4f6;
  border-radius: 8px;
  padding: 0.6rem 0.85rem;
}

/* Carte annuaire compactee (banniere et logo plus petits que sur l'annuaire).
   Seule la carte entreprise est cliquable et anime au survol (ouvre le profil). */
.cs-unit-card {
  width: 200px;
  flex-shrink: 0;
  box-shadow: none;
  border: 1px solid #f3f4f6;
  cursor: pointer;
  transition: box-shadow 0.2s, transform 0.2s;
}

.cs-unit-card:hover {
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

.cs-unit-card .prestataire-card-header {
  height: 64px;
}

/* Logo plus petit et remonte : laisse un large degagement avant le nom (pas de chevauchement) */
.cs-unit-card .prestataire-card-logo-wrapper {
  top: 14px;
  width: 70px;
  height: 64px;
}

.cs-unit-card .prestataire-card-logo-img {
  padding: 4px;
}

.cs-unit-card .prestataire-card-body {
  padding: 3rem 0.7rem 1rem;
  gap: 0.3rem;
}

/* Typo uniforme : nom en tete, infos a la meme taille que .lmm-card-info (1.2rem) */
.cs-unit-card .prestataire-card-nom {
  font-size: 1.3rem;
}

/* Panneau offre (droite) */
.cs-unit-offre {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.35rem;
}

.cs-offre-titre {
  margin: 0 0 0.15rem;
  font-weight: 700;
  font-size: 1.2rem;
  color: #374151;
}

.cs-line {
  margin: 0;
  font-size: 1.2rem;
  color: #374151;
  word-break: break-word;
}

.cs-line-label {
  font-weight: 600;
  color: #595959;
  margin-right: 0.35rem;
}

.cs-line--muted {
  color: #9ca3af;
}

/* Bouton "Offre du candidat" (plis dechiffres) dans le panneau offre. */
.cs-unit-actions {
  margin-top: 0.5rem;
}

/* Empreinte du pli (placeholder chiffrement) : ligne discrete avec cadenas */
.cs-line--seal {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-top: 0.15rem;
  color: #6b7280;
  font-size: 1.05rem;
}

.cs-statut {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
}

.cs-statut--repondu { color: #16a34a; }
/* Attente / refuse / expire / annule : texte en noir, non gras (demande produit) */
.cs-statut--attente,
.cs-statut--refuse,
.cs-statut--annule,
.cs-statut--expire { color: #374151; font-weight: 400; }

/* Skeleton de chargement (meme principe que la page Annuaire) */
@keyframes cs-sk-shimmer {
  0%   { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

.cs-unit--skeleton {
  pointer-events: none;
}

.cs-sk {
  display: block;
  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);
  background-size: 200% 100%;
  animation: cs-sk-shimmer 1.4s ease-in-out infinite;
  border-radius: 4px;
}

.cs-sk-banner { width: 100%; height: 100%; border-radius: 0; }
.cs-sk-logo   { width: 100%; height: 100%; border-radius: 8px; }
.cs-sk-line   { height: 13px; }
.cs-sk-line--nom   { width: 80%; }
.cs-sk-line--sm    { width: 60%; }
.cs-sk-line--title { width: 50%; height: 16px; margin-bottom: 0.3rem; }

.consultation-suivi-warn {
  text-align: center;
  color: #92400e;
  font-size: 1.1rem;
  margin: 0 0 1rem;
}

.form-group label.opms__attestation-label {
  margin-bottom: 0; 
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SuiviOperationMSV2/components/OperationConsultationSuivi.css"],"names":[],"mappings":"AAAA;;;0FAG0F;;AAE1F;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;;kCAEkC;AAClC;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;kFACkF;AAClF;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA,gGAAgG;AAChG;EACE,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,oFAAoF;AACpF;EACE,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,wEAAwE;AACxE;EACE,kBAAkB;AACpB;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,sBAAsB,cAAc,EAAE;AACtC,mFAAmF;AACnF;;;qBAGqB,cAAc,EAAE,gBAAgB,EAAE;;AAEvD,gEAAgE;AAChE;EACE,OAAO,4BAA4B,EAAE;EACrC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yEAAyE;EACzE,0BAA0B;EAC1B,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA,gBAAgB,WAAW,EAAE,YAAY,EAAE,gBAAgB,EAAE;AAC7D,gBAAgB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;AAC/D,gBAAgB,YAAY,EAAE;AAC9B,qBAAqB,UAAU,EAAE;AACjC,qBAAqB,UAAU,EAAE;AACjC,qBAAqB,UAAU,EAAE,YAAY,EAAE,qBAAqB,EAAE;;AAEtE;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb","sourcesContent":["/* Section 2 — Decryptage et ouverture des plis (vue acheteur MS, V2).\n   Une unite par prestataire : carte annuaire (gauche, classes globales .prestataire-card*\n   compactees ici) + panneau d'offre (droite). Horizontal pour limiter la hauteur.\n   Co-localise au fork OperationConsultationSuivi (ne pas dependre du .css de l'oracle). */\n\n.consultation-presta-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.25rem;\n  margin-top: 0.25rem;\n}\n\n.cs-unit {\n  display: flex;\n  gap: 1rem;\n  align-items: stretch;\n  flex: 1 1 320px;\n  padding: 0.75rem;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);\n}\n\n/* Tant que le prestataire n'a pas repondu (refus, expire, attente) : seul le panneau d'offre\n   (droite) passe en gris. La carte annuaire (gauche) reste blanche, sinon elle se confond avec\n   le fond et devient illisible. */\n.cs-unit--grise {\n  background: #fff;\n}\n\n.cs-unit--grise .cs-unit-card {\n  background: #fff;\n}\n\n.cs-unit--grise .cs-unit-offre {\n  background: #f3f4f6;\n  border-radius: 8px;\n  padding: 0.6rem 0.85rem;\n}\n\n/* Carte annuaire compactee (banniere et logo plus petits que sur l'annuaire).\n   Seule la carte entreprise est cliquable et anime au survol (ouvre le profil). */\n.cs-unit-card {\n  width: 200px;\n  flex-shrink: 0;\n  box-shadow: none;\n  border: 1px solid #f3f4f6;\n  cursor: pointer;\n  transition: box-shadow 0.2s, transform 0.2s;\n}\n\n.cs-unit-card:hover {\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);\n  transform: translateY(-2px);\n}\n\n.cs-unit-card .prestataire-card-header {\n  height: 64px;\n}\n\n/* Logo plus petit et remonte : laisse un large degagement avant le nom (pas de chevauchement) */\n.cs-unit-card .prestataire-card-logo-wrapper {\n  top: 14px;\n  width: 70px;\n  height: 64px;\n}\n\n.cs-unit-card .prestataire-card-logo-img {\n  padding: 4px;\n}\n\n.cs-unit-card .prestataire-card-body {\n  padding: 3rem 0.7rem 1rem;\n  gap: 0.3rem;\n}\n\n/* Typo uniforme : nom en tete, infos a la meme taille que .lmm-card-info (1.2rem) */\n.cs-unit-card .prestataire-card-nom {\n  font-size: 1.3rem;\n}\n\n/* Panneau offre (droite) */\n.cs-unit-offre {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0.35rem;\n}\n\n.cs-offre-titre {\n  margin: 0 0 0.15rem;\n  font-weight: 700;\n  font-size: 1.2rem;\n  color: #374151;\n}\n\n.cs-line {\n  margin: 0;\n  font-size: 1.2rem;\n  color: #374151;\n  word-break: break-word;\n}\n\n.cs-line-label {\n  font-weight: 600;\n  color: #595959;\n  margin-right: 0.35rem;\n}\n\n.cs-line--muted {\n  color: #9ca3af;\n}\n\n/* Bouton \"Offre du candidat\" (plis dechiffres) dans le panneau offre. */\n.cs-unit-actions {\n  margin-top: 0.5rem;\n}\n\n/* Empreinte du pli (placeholder chiffrement) : ligne discrete avec cadenas */\n.cs-line--seal {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin-top: 0.15rem;\n  color: #6b7280;\n  font-size: 1.05rem;\n}\n\n.cs-statut {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 600;\n}\n\n.cs-statut--repondu { color: #16a34a; }\n/* Attente / refuse / expire / annule : texte en noir, non gras (demande produit) */\n.cs-statut--attente,\n.cs-statut--refuse,\n.cs-statut--annule,\n.cs-statut--expire { color: #374151; font-weight: 400; }\n\n/* Skeleton de chargement (meme principe que la page Annuaire) */\n@keyframes cs-sk-shimmer {\n  0%   { background-position: -200% 0; }\n  100% { background-position: 200% 0; }\n}\n\n.cs-unit--skeleton {\n  pointer-events: none;\n}\n\n.cs-sk {\n  display: block;\n  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);\n  background-size: 200% 100%;\n  animation: cs-sk-shimmer 1.4s ease-in-out infinite;\n  border-radius: 4px;\n}\n\n.cs-sk-banner { width: 100%; height: 100%; border-radius: 0; }\n.cs-sk-logo   { width: 100%; height: 100%; border-radius: 8px; }\n.cs-sk-line   { height: 13px; }\n.cs-sk-line--nom   { width: 80%; }\n.cs-sk-line--sm    { width: 60%; }\n.cs-sk-line--title { width: 50%; height: 16px; margin-bottom: 0.3rem; }\n\n.consultation-suivi-warn {\n  text-align: center;\n  color: #92400e;\n  font-size: 1.1rem;\n  margin: 0 0 1rem;\n}\n\n.form-group label.opms__attestation-label {\n  margin-bottom: 0; \n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
